<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div id="square7" class="square square-7" style="transform: perspective(500px) rotateY(11.45deg) rotateX(0.123333deg);"></div>
        <div id="square8" class="square square-8" style="transform: perspective(500px) rotateY(11.45deg) rotateX(0.123333deg);"></div>
        <div class="card card-register">
          <div class="card-header">
            <img class="card-img" src="../assets/img/square1.png" alt="Card image" title="" style="">
            <h4 class="card-title reset-title">reset <br> password</h4>
          </div>
          <form class="form" @submit.prevent="submit">
            <div class="card-body">
              <label for="">You will be sent an email with instructions to reset your password.</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i class="ion ion-md-person"></i>
                  </div>
                </div>
                <input type="text" placeholder="email" class="form-control" v-model="email">
              </div>
              <div :class="{'text-success': !message_error,'text-danger': message_error}">
                {{ message }}
              </div>
            </div>
            <div class="card-footer d-flex justify-content-between align-items-center">
              <button type="submit" href="javascript:void(0)" @click.prevent.stop="submit" class="btn btn-info btn-round btn-lg">Reset Password</button>
              <router-link :to="{name: 'login'}">Log In</router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="register-bg"></div>
    <div id="square1" class="square square-1" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
    <div id="square2" class="square square-2" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
    <div id="square3" class="square square-3" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
    <div id="square4" class="square square-4" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
    <div id="square5" class="square square-5" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
    <div id="square6" class="square square-6" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
  </div>
</template>

<script>
import userService from '@/services/userService'

export default {
  name: '',
  data () {
    return {
      email: '',
      message: '',
      message_error: false
    }
  },
  created () {
  },
  computed: {
  },
  methods: {
    submit () {
      this.message = ''
      this.message_error = false
      userService.resetPassword(this.email).then(() => {
        this.message = 'Your password has been reset. Check your email for the reset link.'
      }).catch(err => {
        this.message_error = true
        this.message = err.response.data.email[0]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.card-register .card-header .card-title.reset-title {
  font-size: 3em;
  margin-left: -3px;
}
</style>
